import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Route, NavLink, useHistory, useLocation, Redirect, Switch } from 'react-router-dom';

import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';

import SettingsIcon from '@material-ui/icons/Settings';
import BrandIcon from '@material-ui/icons/ColorLens';
import OnboardingIcon from '@material-ui/icons/Publish';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import SubscriptionIcon from '@material-ui/icons/Subscriptions';
import AdvancedIcon from '@material-ui/icons/Tune';

import ClubAvatar from 'app/components/club/ClubAvatar';
import General from 'app/components/club/General';
import Branding from 'app/components/club/Branding';
import Onboarding from 'app/components/club/Onboarding';
import Fields from 'app/components/club/Fields';
import Advanced from 'app/components/club/Advanced';

import useApp from 'app/context/useApp';
import { containerFlex, containerFlexGrow, containerFlexFixedSmall } from 'app/styles/new-layout';

const useStyles = makeStyles(theme => ({
    container: {
        ...containerFlex(theme),
        padding: theme.spacing(3)
    },
    nav: {
        ...containerFlexFixedSmall(theme),
    },
    content: {
        ...containerFlexGrow(theme),
        paddingLeft: theme.spacing(3),

        [theme.breakpoints.down('sm')]: {
            paddingLeft: '0px',
        }
    },
    title: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3)
    },
    menuItem: {
        borderRadius: theme.shape.borderRadius
    },
    bottomNavigation: {
        position: 'fixed',
        bottom: '0px',
        left: '0px',
        width: '100%',
        zIndex: '10',
        boxShadow: theme.shadows[5],

        [theme.breakpoints.up('md')]: {
            display: 'none',
        }
    },
    bottomNavigationAction: {
        minWidth: '60px',
    },
}));

export default function Settings(props) {

    const { app } = useApp();
    const classes = useStyles();

    let history = useHistory();
    let location = useLocation();

    const pathname = location.pathname;

    const isSelected = tab => {
        return (tab === pathname);
    }

    const handleBottomNavChange = (event, value) => {
        history.push(value);
    }

    return (
        <div className={classes.container}>
            <div className={classes.nav}>
                <ClubAvatar club={app.club} />
                <div className={classes.title}>
                    <Typography variant="h6" align="center">
                        {app.club.name}
                    </Typography>
                    {(app.club.short_description != '') &&
                        <Typography variant="subtitle2" align="center" color="textSecondary">
                            {app.club.short_description}
                        </Typography>
                    }
                </div>
                <Divider/>
                <MenuList>
                    <MenuItem
                        to="/admin/settings"
                        component={NavLink}
                        className={classes.menuItem}
                        selected={isSelected("/admin/settings")}
                        >
                        <ListItemIcon>
                            <SettingsIcon />
                        </ListItemIcon>
                        <ListItemText primary="General Settings" />
                    </MenuItem>
                    <MenuItem
                        to="/admin/settings/branding"
                        component={NavLink}
                        className={classes.menuItem}
                        selected={isSelected("/admin/settings/branding")}
                        >
                        <ListItemIcon>
                            <BrandIcon />
                        </ListItemIcon>
                        <ListItemText primary="Branding" />
                    </MenuItem>
                    <MenuItem
                        to="/admin/settings/onboarding"
                        component={NavLink}
                        className={classes.menuItem}
                        selected={isSelected("/admin/settings/onboarding")}
                        >
                        <ListItemIcon>
                            <OnboardingIcon />
                        </ListItemIcon>
                        <ListItemText primary="Onboarding" />
                    </MenuItem>
                    <MenuItem
                        to="/admin/settings/fields"
                        component={NavLink}
                        className={classes.menuItem}
                        selected={isSelected("/admin/settings/fields")}
                        >
                        <ListItemIcon>
                            <TextFieldsIcon />
                        </ListItemIcon>
                        <ListItemText primary="Custom Fields" />
                    </MenuItem>
                    <MenuItem
                        to="/admin/settings/subscription"
                        component={NavLink}
                        className={classes.menuItem}
                        selected={isSelected("/admin/settings/subscription")}
                        >
                        <ListItemIcon>
                            <SubscriptionIcon />
                        </ListItemIcon>
                        <ListItemText primary="Subscription" />
                    </MenuItem>
                    <MenuItem
                        to="/admin/settings/advanced"
                        component={NavLink}
                        className={classes.menuItem}
                        selected={isSelected("/admin/settings/advanced")}
                        >
                        <ListItemIcon>
                            <AdvancedIcon />
                        </ListItemIcon>
                        <ListItemText primary="Advanced Settings" />
                    </MenuItem>
                </MenuList>
            </div>
            <div className={classes.content}>
                <Switch>
                    <Route
                        path={'/admin/settings'}
                        exact
                        render={() => <General app={app} /> }
                    />
                    <Route
                        path={'/admin/settings/branding'}
                        exact
                        render={() => <Branding app={app} />}
                    />
                    <Route
                        path={'/admin/settings/onboarding'}
                        exact
                        render={() => <Onboarding app={app} />}
                    />
                    <Route
                        path={'/admin/settings/fields'}
                        exact
                        render={() => <Fields app={app} />}
                    />
                    <Route
                        path={'/admin/settings/subscription'}
                        exact
                    />
                    <Route
                        path={'/admin/settings/advanced'}
                        exact
                        render={() => <Advanced app={app} />}
                    />
                    <Redirect from={"/admin/settings/*"} to="/admin/settings"></Redirect>
                </Switch>
            </div>
            <BottomNavigation
                onChange={handleBottomNavChange}
                value={pathname}
                className={classes.bottomNavigation}
                >
                <BottomNavigationAction label="General" value="/admin/settings" icon={<SettingsIcon/>}
                    classes={{ root: classes.bottomNavigationAction }} />
                <BottomNavigationAction label="Branding" value="/admin/settings/branding" icon={<BrandIcon/>}
                    classes={{ root: classes.bottomNavigationAction }} />
            </BottomNavigation>
        </div>
    );
}
